import { PricingFormInput } from '../../../../../../../../store/features/delegate/types';
import { PricingFormInputType } from '../../../../../../../../types/enums';
import { DelegateFormProps } from '../../../../index';
import AdHocFieldWithOptions from '../AdHocFieldWithOptions';
import AdHocField from '../AdHocField';

export interface AdHocFieldGeneratorProps
  extends Pick<DelegateFormProps, 'delegateUuid'> {
  formInput: PricingFormInput;
  allFormInputs: PricingFormInput[];
}

export default function AdHocFieldGenerator(props: AdHocFieldGeneratorProps) {
  const { delegateUuid, formInput, allFormInputs } = props;

  switch (formInput.type) {
    case PricingFormInputType.SELECT:
    case PricingFormInputType.RADIO:
    case PricingFormInputType.CHECKBOX_GROUP: {
      return (
        <AdHocFieldWithOptions
          delegateUuid={delegateUuid}
          formInput={formInput}
          allFormInputs={allFormInputs}
        />
      );
    }

    default: {
      return <AdHocField formInput={formInput} />;
    }
  }
}
